import React, { createContext, useReducer } from 'react';
const tpl_globalState = {
    app_config: { authToken: null, authEnv: null, gsUserToken: null, gsUserId: null, gsApiKey: null },
    app_gsclient: null,
    app_stage: '',
    idxs: { ch_list: {}, prime_unread: [], prime_categories: {} },
    drawer: { is_open: false, tab: null },
    search: { input: '', unread: false, archive: false },
    jumpTo: {}
};

export const GlobalContext = createContext(tpl_globalState);
export const GlobalProvider = ({ children }) => {
	const [globalState, dispatch] = useReducer(AppReducer, tpl_globalState);
	// Actions/Functions for changing state
	const setGlobalState = {
		'connect': payload => dispatch({ type: 'CONNECT', payload: payload }),
        'disconnect': payload => dispatch({ type: 'DISCONNECT', payload: payload }),
        'error': payload => dispatch({ type: 'ERROR', payload: payload }),
		'boot': payload => dispatch({ type: 'BOOT', payload: payload }),
		'drawer': payload => dispatch({ type: 'DRAWER', payload: payload }),
        'search': payload => dispatch({ type: 'SEARCH', payload: payload }),
		'setJumpTo': payload => dispatch({ type: 'SET_JUMP_TO', payload: payload }),
		'chList': payload => dispatch({ type: 'CH_LIST', payload: payload })
	};
	return(
		<GlobalContext.Provider value={{'globalState': globalState, 'setGlobalState': setGlobalState}}>
			{children}
		</GlobalContext.Provider>
	);
};
const AppReducer = (state, action) => {
	try {
        switch(action.type) {
            case 'CONNECT':
                return { ...tpl_globalState, 'app_stage': 'connected', 'app_config': action.payload.app_config, 'app_gsclient': action.payload.app_gsclient };
            case 'DISCONNECT':
                return { ...state, 'app_stage': 'disconnected' };
            case 'ERROR':
                if (action.payload) return { ...state, 'app_stage': `error-${action.payload}` };
                return { ...state, 'app_stage': 'error' };
            case 'BOOT':
                return { ...state, 'app_stage': 'booted', 'idxs': action.payload };
            case 'DRAWER':
                if (action.payload.switch === true) {
                    return { ...state, 'search': { ...tpl_globalState.search }, 'drawer': { is_open: true, tab: action.payload.tab } };
                }
                if ((state.drawer.is_open === true && state.drawer.tab !== action.payload) || state.drawer.is_open === false) {
                    return { ...state, 'search': { ...tpl_globalState.search }, 'drawer': { is_open: true, tab: action.payload } };
                }
                return { ...state, 'drawer': { is_open: false, tab: null } };
            case 'SEARCH':
                if (action.payload.type === 'input') return { ...state, 'search': { ...state.search, input: action.payload.value } };
                return { ...state, 'search': { ...state.search, [action.payload]: !state.search[action.payload] } };
            case 'SET_JUMP_TO':
                if (action.payload.switch === true) {
                    return { ...state, 'jumpTo': {...action.payload}, 'drawer': { is_open: state.drawer.is_open, tab: action.payload.ch_type }, 'search': { ...tpl_globalState.search, archive: action.payload.frozen === true } };
                }
                return { ...state, 'jumpTo': {} };
            case 'CH_LIST':
                if (typeof action.payload === 'string' && Object.keys(state.idxs.ch_list).includes(action.payload) === true) {
                    delete state.idxs.ch_list[action.payload];
                }
                if (typeof action.payload === 'object' && Array.isArray(action.payload) === false && action.payload !== null) {
                    state.idxs.ch_list = { ...state.idxs.ch_list, ...action.payload };
                }
                return {...state};
            default:
                return state;
        };
    } catch (error) {
        console.log('Error', error);
    }
};

